import { createBemBlockBuilder } from "@ebsco-ui/utils";
import { ButtonProps } from "@ebsco-ui/button";
import { BOOLEAN_CHIP_VALUE, BOOLEAN_ITEMS } from "./constants";

import "./boolean-chip.scss";

const baseClassName = "eb-boolean-chip";

export type BooleanChipValueMessages = {
  [K in `${BOOLEAN_CHIP_VALUE}`]: string;
};

export interface BooleanChipProps extends Omit<ButtonProps, "onChange"> {
  onChange: (value: BOOLEAN_CHIP_VALUE) => void;
  className?: string;
  booleanItems?: string[];
  value: BOOLEAN_CHIP_VALUE;
  messages: {
    getPosition: (currentPosition: number, total: number) => string;
    ariaRoledescription: string;
  } & BooleanChipValueMessages;
}

const BooleanChip = ({
  className: consumerClassname,
  onChange,
  value,
  messages,
  ...props
}: BooleanChipProps) => {
  const { getPosition, ariaRoledescription } = messages;
  const currentPosition = BOOLEAN_ITEMS.indexOf(value) + 1;
  const total = BOOLEAN_ITEMS.length;

  const onClick = () => {
    const nextIndex = currentPosition % total;

    onChange(BOOLEAN_ITEMS[nextIndex] as BOOLEAN_CHIP_VALUE);
  };

  const getBEMBlockWith = createBemBlockBuilder([
    baseClassName,
    consumerClassname,
  ]);

  return (
    <button
      aria-roledescription={ariaRoledescription}
      type="button"
      className={getBEMBlockWith()}
      onClick={onClick}
      {...props}
    >
      <span aria-live="polite" className={getBEMBlockWith("__button-text")}>
        {messages[value]}
        <span className={getBEMBlockWith("__order")}>{`, ${getPosition(
          currentPosition,
          total,
        )}`}</span>
      </span>
    </button>
  );
};

export default BooleanChip;
